// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__6Dm-P","content":"LayoutSettings_content__1-yc2"};